import { useEffect, useState } from "react";
import { FacebookLoginButton } from "react-social-login-buttons";
import {useFormContext} from "react-hook-form";

function Fb() {
    const [profile, setProfile] = useState(null);
    const [showEmail, setShowEmail] = useState(true);
    const { setValue } = useFormContext();

    useEffect(() => {
        // Load Facebook SDK
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: "1749188705905037",
                xfbml: true,
                version: "v18.0",
            });
        };

        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }, []);

    const handleFBLogin = () => {
        window.FB.login(
            function (response) {
                if (response.authResponse) {
                    window.FB.api("/me", { fields: "name,picture,email" }, function (userData) {
                        let emailValue = userData.email;
                        let displayEmail = true;

                        if (!emailValue || emailValue.trim() === "") {
                            emailValue = userData.name;
                            displayEmail = false;
                        }
                        setProfile({ ...userData, email: emailValue });
                        setShowEmail(displayEmail);
                        setValue("email", emailValue);
                        setValue("token", response.authResponse.accessToken);
                    });
                }
            },
            {
                config_id: "760713373225696",
                scope: 'ads_management,public_profile,email,pages_read_engagement',
                response_type: "token",
                override_default_response_type: true,
            }
        );
    };
    return (
        <div>
            {!profile ? (
                <div>
                    <div className="create-destination__platform-header">Authorize your Meta connection:</div>
                    <FacebookLoginButton onClick={handleFBLogin} />
                </div>
            ) : (
                <div>
                    <div className="create-destination__platform-header">Authorized to Meta as:</div>
                    <div className="flex flex-col gap-2">
                        <div className="create-destination__platform-profile">{profile.name}</div>
                        {showEmail && (
                            <div className="create-destination__platform-profile">({profile.email})</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Fb;